import { render, staticRenderFns } from "./ModalGroupCategoryProductEdit.vue?vue&type=template&id=6f45819a&scoped=true"
import script from "./ModalGroupCategoryProductEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupCategoryProductEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupCategoryProductEdit.vue?vue&type=style&index=0&id=6f45819a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f45819a",
  null
  
)

export default component.exports